"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable object-shorthand */
var _ = require('lodash');
var moment = require('moment');
var _require = require('../../../../common/constant/finding-status.constant'),
  COMPLIANT = _require.COMPLIANT,
  IN_PROGRESS = _require.IN_PROGRESS,
  NO_FURTHER_ACTION = _require.NO_FURTHER_ACTION,
  NOT_RESOLVED = _require.NOT_RESOLVED,
  NA = _require.NA,
  READY_FOR_VERIFICATION = _require.READY_FOR_VERIFICATION,
  RESOLVED = _require.RESOLVED;
var _require2 = require('../../../../common/constant/finding-value.constant'),
  NOT_COMPLIANT = _require2.NOT_COMPLIANT;
var _require3 = require('../../../../common/constant/report-status.constant'),
  DONE = _require3.DONE,
  DRAFT = _require3.DRAFT,
  SENT_TO_RP = _require3.SENT_TO_RP;
module.exports = /*@ngInject*/function () {
  return {
    restrict: 'AE',
    scope: true,
    bindToController: {
      incident: '=',
      finding: '=',
      report: '=',
      series: '=',
      optionsVisible: '=',
      parentInit: '&',
      showPhoto: '&',
      showHistory: '&',
      isPublicView: '=',
      isInspectorAndAdminView: '='
    },
    templateUrl: 'shared/components/incident-details/incident.details.html',
    controllerAs: 'sCtrl',
    controller: /*@ngInject*/function controller($anchorScroll, $location, $filter, $uibModal, $q, Upload, PreferenceService, ProfileService, ReportService, $routeParams) {
      var sCtrl = this;
      sCtrl.reportStatuses = {
        DONE: DONE,
        DRAFT: DRAFT,
        SENT_TO_RP: SENT_TO_RP
      };
      sCtrl.findingStatuses = {
        COMPLIANT: COMPLIANT,
        IN_PROGRESS: IN_PROGRESS,
        NA: NA,
        NO_FURTHER_ACTION: NO_FURTHER_ACTION,
        NOT_RESOLVED: NOT_RESOLVED,
        READY_FOR_VERIFICATION: READY_FOR_VERIFICATION,
        RESOLVED: RESOLVED
      };
      sCtrl.findingValues = {
        NOT_COMPLIANT: NOT_COMPLIANT
      };
      sCtrl.hideInfoOnPrint = ProfileService.redactInspectorsOnPrint();
      sCtrl.activeIncidentId = $routeParams.activeIncidentId;
      sCtrl.hasPermission = function (obj, permission) {
        return obj.permissions && obj.permissions.indexOf(permission) >= 0;
      };
      sCtrl.getResolutionHeader = function (resolution) {
        var actionName = $filter('camelcase')(resolution.action);
        var style = $filter('lowercase')(resolution.action);
        var headerText = "<strong class=\"status text-".concat(style, "\">").concat(actionName, "&nbsp;</strong>");
        return headerText;
      };
      sCtrl.dueDate = null;
      sCtrl.dueReminderDate = null;
      sCtrl.showDueDaysMessage = false;
      sCtrl.init = function (report, finding, incident, isPublicView) {
        sCtrl.showPrivateComment = isPublicView || !report._id ? false : ProfileService.isInspector(report.configuration) || ProfileService.isAdminForProgram(report.configuration.program);
        sCtrl.report = report;
        if (incident.daysToResolve && report.sentToRPDate) {
          sCtrl.dueDate = moment(report.sentToRPDate).add(incident.daysToResolve || 0, 'days').endOf('date');
          sCtrl.showDueDaysMessage = moment().startOf('date').isAfter(sCtrl.dueDate);
        }
        if (report.configuration.reminderNotificationDays && sCtrl.dueDate) {
          sCtrl.dueReminderDate = moment(sCtrl.dueDate).endOf('date').subtract(report.configuration.reminderNotificationDays || 0, 'days');
          sCtrl.showDueDaysMessage = moment().endOf('date').isSameOrAfter(sCtrl.dueReminderDate);
        }
        sCtrl.squashedResolutions = sCtrl.squashResolutions(incident.resolutions);
        sCtrl.latestResolution = sCtrl.squashedResolutions[sCtrl.squashedResolutions.length - 1];
        sCtrl.scrollTo();
      };
      sCtrl.scrollTo = function () {
        if (sCtrl.activeIncidentId) {
          $location.search('activeIncidentId', null);
          $location.hash(sCtrl.activeIncidentId);
          // eslint-disable-next-line no-param-reassign
          $anchorScroll.yOffset = 300;
          $anchorScroll();
        }
      };
      sCtrl.squashResolutions = function (incidentResolutions) {
        return incidentResolutions.reduce(function (squashed, current) {
          var squashObj = squashed[squashed.length - 1];
          if (!squashObj || current.action !== squashObj.action) {
            squashed.push({
              action: current.action,
              resolutions: [current]
            });
          } else {
            squashObj.resolutions.push(current);
          }
          return squashed;
        }, []);
      };
      sCtrl.hasDueDate = function (incident) {
        return (incident.status === NOT_RESOLVED || incident.status === IN_PROGRESS) && incident.value === NOT_COMPLIANT && sCtrl.showDueDaysMessage;
      };
      sCtrl.isVerificationRequired = function (incident) {
        return incident.requiresVerification && incident.value === NOT_COMPLIANT && (incident.status === NOT_RESOLVED || incident.status === IN_PROGRESS || incident.status === READY_FOR_VERIFICATION);
      };
      sCtrl.resolve = function (report, finding, incident, action) {
        $uibModal.open({
          templateUrl: 'shared/components/incident-details/_resolution.form.html',
          // eslint-disable-next-line no-unused-vars, no-shadow
          controller: /*@ngInject*/function controller($uibModalInstance, Upload, $scope) {
            var ctrl = this;
            ctrl.uploadProgress = false;
            ctrl.files = [];
            ctrl.errorFiles = [];
            ctrl.opened = {};
            ctrl.dateFormats = ['yyyy-MM-dd', 'MM/dd/yyyy', 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
            ctrl.actionName = $filter('camelcase')(action);
            ctrl.resolution = {
              comments: null,
              tracking: incident.workOrderNumber || null,
              attachments: [],
              resolutionDate: ctrl.actionName === 'Resolved' ? new Date() : null
            };
            ctrl.getAcceptedAttachmentFormats = ReportService.ACCEPTED_ATTACHMENT_FORMATS;
            ctrl.open = function (item) {
              ctrl.opened[item] = true;
            };
            ctrl.recentAttachments = [];
            ctrl.cancel = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
              return _regenerator["default"].wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    $uibModalInstance.dismiss('dismiss');
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            ctrl.addAttachments = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
              return _regenerator["default"].wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(ctrl.files && ctrl.files.length)) {
                      _context3.next = 4;
                      break;
                    }
                    ctrl.uploadProgress = true;
                    _context3.next = 4;
                    return Promise.allSettled(ctrl.files.map(/*#__PURE__*/function () {
                      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
                        var fileType, _yield$ReportService$, uploadedFile, error, _yield$ReportService$2, signedUrl, attachment;
                        return _regenerator["default"].wrap(function _callee2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              fileType = file.type && file.type.indexOf('image') > -1 ? 'IMAGE' : 'DOCUMENT';
                              _context2.next = 3;
                              return ReportService.uploadFile(file);
                            case 3:
                              _yield$ReportService$ = _context2.sent;
                              uploadedFile = _yield$ReportService$.uploadedFile;
                              error = _yield$ReportService$.error;
                              if (!error) {
                                _context2.next = 11;
                                break;
                              }
                              ctrl.errorFiles.push({
                                fileName: file.name,
                                error: error
                              });
                              _.remove(ctrl.files, _.find(ctrl.files, file));
                              _context2.next = 20;
                              break;
                            case 11:
                              _context2.next = 13;
                              return ReportService.downloadFile(uploadedFile.name);
                            case 13:
                              _yield$ReportService$2 = _context2.sent;
                              signedUrl = _yield$ReportService$2.signedUrl;
                              _context2.next = 17;
                              return ReportService.createAttachmentData(uploadedFile, signedUrl, fileType);
                            case 17:
                              attachment = _context2.sent;
                              ctrl.resolution.attachments.push(attachment);
                              ctrl.recentAttachments.push(attachment);
                            case 20:
                            case "end":
                              return _context2.stop();
                          }
                        }, _callee2);
                      }));
                      return function (_x) {
                        return _ref3.apply(this, arguments);
                      };
                    }()));
                  case 4:
                    ctrl.uploadProgress = false;
                    ctrl.files = [];
                    ctrl.errorFiles = [];
                    if (!$scope.$$phase) $scope.$apply();
                  case 8:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            ctrl.viewAttachment = function (attachment) {
              ctrl.lightbox = attachment;
            };
            ctrl.deleteAttachment = function (attachment) {
              var removeIndex = ctrl.resolution.attachments.findIndex(function (attach) {
                return attachment.id === attach.id;
              });
              if (removeIndex > -1) {
                ctrl.resolution.attachments.splice(removeIndex, 1);
              }
            };
            ctrl.updateResolution = function (res) {
              var resolution = res || {};
              resolution.comments = resolution.comments || null;
              resolution.tracking = resolution.tracking || null;
              resolution.attachments = resolution.attachments || [];
              resolution.resolutionDate = resolution.resolutionDate || null;
              var data = {
                action: action,
                findingId: finding.id,
                incidentId: incident.id,
                resolution: resolution || {}
              };
              ctrl.resolutionProgress = true;
              ReportService.removeUnsavedAttachments(ctrl.recentAttachments, resolution.attachments);
              ReportService.updateResolution({
                id: report._id
              }, data).$promise.then(function (result) {
                sCtrl.parentInit()(result);
                $uibModalInstance.close({
                  $value: true
                });
              })["catch"](function (error) {
                return $uibModalInstance.close({
                  $value: error
                });
              });
            };
          },
          controllerAs: '$ctrl',
          backdrop: 'static'
        });
      };
      sCtrl.discussionBoard = function (report, finding, incident) {
        $uibModal.open({
          templateUrl: 'shared/components/incident-details/_discussion.board.html',
          windowClass: 'discussion-model',
          controller: /*@ngInject*/function controller($uibModalInstance) {
            var ctrl = this;
            ctrl.loading = true;
            ctrl.discussions = incident.discussions || [];
            ReportService.getDiscussionRecipients({
              id: report._id,
              findingId: finding.id,
              incidentId: incident.id
            }).$promise.then(function (results) {
              ctrl.emailGroups = results;
              ctrl.loading = false;
            });
            ctrl.discussion = {
              comments: null,
              emailTo: []
            };
            ctrl.emailToList = function (emailTo) {
              if (emailTo.length && emailTo[0].firstName) {
                return emailTo.map(function (person) {
                  return "".concat(person.firstName, " ").concat(person.lastName);
                }).join(', ');
              }
              return emailTo.join(', ');
            };
            ctrl.getResults = function (query, array) {
              return _.filter(array, function (result) {
                return result.text.toLowerCase().indexOf(query.toLowerCase()) > -1;
              });
            };
            ctrl.cancel = function () {
              return $uibModalInstance.dismiss('dismiss');
            };
            ctrl.addComments = function (discussion) {
              var params = {
                id: report._id,
                findingId: finding.id,
                incidentId: incident.id
              };
              var discussionToAdd = {
                comments: discussion.comments,
                emailTo: ctrl.mapToNotificationPerson(discussion.emailTo),
                notificationId: null
              };
              ReportService.addDiscussion(params, discussionToAdd).$promise.then(function (result) {
                ctrl.progress = false;
                // eslint-disable-next-line no-param-reassign
                incident.discussions = result.discussions;
                $uibModalInstance.close({
                  $value: true
                });
              })["catch"](function (error) {
                return $uibModalInstance.close({
                  $value: error
                });
              });
            };
            ctrl.mapToNotificationPerson = function (emailTo) {
              if (!emailTo) {
                return [];
              }
              return emailTo.map(function (person) {
                return _.pick(person, ['firstName', 'lastName', 'userId']);
              });
            };
          },
          controllerAs: '$ctrl',
          backdrop: 'static'
        });
      };
      sCtrl.editIncident = function (reportId, findingId, incidentId, status) {
        PreferenceService.save("".concat(reportId, "_categories"), sCtrl.report.categories);
        $location.path("/report/".concat(reportId, "/finding/").concat(findingId, "/incident/").concat(incidentId)).search({
          status: status
        });
      };
    }
  };
};